module.exports = __webpack_public_path__ + "img/mascot-captain.a68d6445.svg";